import React from "react";
import { Formik, Form, useField } from "formik";
import * as Yup from "yup";
import {
  Box,
  FormControl,
  FormControlLabel,
  FormLabel,
  Radio,
  RadioGroup,
  TextField,
} from "@mui/material";
import { useThemes } from "../../../components/Theme/theme";

// Custom Radio Button component for Formik
const CustomRadioButton = ({ formik, arr, name, label, disabled }) => {
  const { theme } = useThemes();
  return (
    <Box
      sx={{
        position: "relative",
        border: "1px solid #443d3dde",
        borderRadius: "4px",
        padding: "4px",
      }}
    >
      <FormLabel
        sx={{
          position: "absolute",
          top: "-10px",
          left: "10px",
          background: theme?.palette?.TmId.id.toString().includes("9")
            ? "#1e1e1e"
            : "white",
          padding: "0 5px",
          fontSize: "0.8rem",
        }}
        component="legend"
      >
        {label}
      </FormLabel>
      <FormControl component="fieldset" sx={{ marginLeft: "4px" }}>
        <RadioGroup
          row
          aria-label={name}
          name={name}
          value={formik.values[name]}
          onClick={(e) => formik.setFieldValue(name, e.target.value)}
        >
          {arr.map((ar) => (
            <FormControlLabel
              value={ar.value}
              control={<Radio />}
              label={ar.label}
              disabled={disabled}
            />
          ))}
        </RadioGroup>
      </FormControl>
    </Box>
  );
};
export default CustomRadioButton;
// Validation schema
// const validationSchema = Yup.object({
//   receivedBy: Yup.string().required('Required')
// });

// const MyForm = () => {
//   return (
//     <Formik
//       initialValues={{ receivedBy: '' }}
//       validationSchema={validationSchema}
//       onSubmit={(values, { setSubmitting }) => {
//         setTimeout(() => {
//           alert(JSON.stringify(values, null, 2));
//           setSubmitting(false);
//         }, 400);
//       }}
//     >
//       {() => (
//         <Form>
//           <FormikRadioGroup
//             name="receivedBy"
//             label="Received By"
//           />
//           <button type="submit">Submit</button>
//         </Form>
//       )}
//     </Formik>
//   );
// };
